import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuthStore } from '../store/authStore'
import { useCartCount } from '../store/cartStore'

// Shared top bar for the public storefront pages (products, product detail,
// cart). Carries the cart badge so the basket is reachable from anywhere in
// the buying flow.
export default function StorefrontNav({ appName = 'Provisyer' }: { appName?: string }) {
  const { t } = useTranslation()
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  const count = useCartCount()

  return (
    <nav className="relative bg-white/80 backdrop-blur-md border-b border-black/[0.06] px-6 py-4 flex items-center justify-between">
      <div className="flex items-center gap-6">
        <Link to="/" className="text-lg font-bold text-gray-900">{appName}</Link>
        <Link to="/urunler" className="hidden sm:block text-sm text-gray-600 hover:text-gray-900">
          {t('products.navProducts')}
        </Link>
        <Link to="/pricing" className="hidden sm:block text-sm text-gray-600 hover:text-gray-900">
          {t('products.navPricing')}
        </Link>
      </div>
      <div className="flex items-center gap-4">
        <Link
          to="/sepet"
          className="relative flex items-center gap-1.5 text-sm text-gray-600 hover:text-gray-900"
          aria-label={t('cart.title')}
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.8}
              d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.3 2.3A1 1 0 005.4 17H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
            />
          </svg>
          <span className="hidden sm:inline">{t('cart.title')}</span>
          {count > 0 && (
            <span className="absolute -top-2 -right-2 sm:static sm:ml-1 min-w-[18px] h-[18px] px-1 rounded-full bg-brand-600 text-white text-[11px] font-semibold flex items-center justify-center">
              {count}
            </span>
          )}
        </Link>
        {isAuthenticated ? (
          <Link to="/dashboard" className="text-sm text-brand-600 hover:text-brand-700 font-medium">
            {t('pricing.dashboard')}
          </Link>
        ) : (
          <>
            <Link to="/login" className="text-sm text-gray-600 hover:text-gray-900">
              {t('pricing.signIn')}
            </Link>
            <Link
              to="/register"
              className="bg-brand-600 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-brand-700 transition-colors"
            >
              {t('pricing.getStarted')}
            </Link>
          </>
        )}
      </div>
    </nav>
  )
}
